import { Routes } from '@angular/router';
import { authGuard } from '@pkp/core';

export const DESKTOP_SEARCH_MAIN_ROUTES: Routes = [
  {
    path: 'parking-details/:id',
    loadComponent: () =>
      import('../../../../shared/parking-details-page/parking-details-page.component').then(
        c => c.ParkingDetailsPageComponent,
      ),
  },
  {
    path: 'sign-segment/:uuid',
    loadComponent: () =>
      import('../../../../shared/sign-segment-page/sign-segment-page.component').then(
        c => c.SignSegmentPageComponent,
      ),
  },
  {
    path: 'parking-order/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../parking-order/parking-order.component').then(c => c.DesktopParkingOrderComponent),
  },
];
